import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-10', 'Number10', [["path",{"d":"M8 20v-16l-5 5"}],["path",{"d":"M16 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4"}]]);